<template>
  <div class="bao">
    <el-card class="box-card contaier">
      <div class="title">
        <span class="perInfo">{{ $t("person.title.info1") }}</span>
        <span class="pro"
          >{{ $t("person.title.info2") }}<i>{{ $t("person.title.info3") }}</i
          >{{ $t("person.title.info4") }}</span
        >
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('person.tabs.tab1')" name="first"
          ><BaseInfo ref="BaseInfo"
        /></el-tab-pane>

        <el-tab-pane :label="$t('person.tabs.tab2')" name="second"
          ><Letter ref="Letter"
        /></el-tab-pane>

        <el-tab-pane :label="$t('person.tabs.tab3')" name="third">
          <span slot="label">
            {{ $t("person.tabs.tab3") }}<el-badge :is-dot="badgeMsg"
          /></span>
          <Quest @func="getMsgFormSon" ref="Quest" />
        </el-tab-pane>

        <el-tab-pane :label="$t('person.tabs.tab5')" name="fifth"
          ><Password ref="Password"
        /></el-tab-pane>
      </el-tabs>
    </el-card>

    <div
      class="box12"
      v-if="
        activeName == 'first' || activeName == 'third' || activeName == 'fifth'
      "
    >
      <button class="saveBtn" @click="submit()">
        {{ $t("common.submit") }}
      </button>
    </div>
  </div>
</template>
<script>
import BaseInfo from "./components/baseInfo.vue"; //个人信息
import Letter from "./components/confirmLetter.vue"; //确认函
import Quest from "./components/questionnaire.vue"; // 问卷调查
import Group from "./components/group.vue"; // 团体注册
import Password from "./components/changepassword.vue"; //密码变更
export default {
  data() {
    return {
      activeName: "first",
      badgeMsg: false, //默认值
    };
  },
  components: {
    BaseInfo,
    Letter,
    Quest,
    Group,
    Password,
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //获取子组件的信息
    getMsgFormSon(data) {
      this.badgeMsg = data;
    },

    //调用子组件的方法
    submit() {
      console.log(this.activeName);
      if (this.activeName == "first") {
        //基本信息
        this.$refs.BaseInfo.submit();
      } else if (this.activeName == "second") {
        //确认函
      } else if (this.activeName == "third") {
        //调查问卷
        this.$refs.Quest.submit();
      } else if (this.activeName == "fifth") {
        //修改密码
        this.$refs.Password.submit();
      } else {
        console.log("执行出了bug!");
      }
    },
  },

  //组合监听路由参数变化
  watch: {
    $route() {
      const id = this.$route.query.positionId;
      this.activeName = id;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const id = vm.$route.query.positionId;
      vm.activeName = id;
    });
  },
};
</script>
<style lang="scss" scoped>
.bo {
  background-color: white;
  padding: 0px 15px;
  box-sizing: border-box;

  
}
.bao {
  padding-top: 50px;

}
.contaier {
   margin: 10px 10px 0px 10px;
   background-color: #F0F2F5;

  .title {
    display: flex;
    justify-content: flex-start;
    background-color: white;
    padding: 20px 10px 0px 10px;
    box-sizing: border-box;
    .perInfo {
      width: fit-content;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 25px;
    }
    .pro {
      flex: 1;
       margin-left: 26px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 25px;
      i {
        font-style: normal;
        color: red;
      }
    }
  }
}
</style>
<style scoped>
.bao >>> .el-card__body {
  padding: 0px;
}
.bao >>> .el-tabs__header {
  background-color: white;
  padding: 0px 15px;
  box-sizing: border-box;
}
.bao >>> .el-tabs__content {
  position: relative;
  top: -10px;
}
.bao >>> .el-form{
   padding-top: 25px;
}
.el-tabs >>> .el-tabs__item.is-active {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #006fb8;
}
.el-tabs >>> .el-tabs__item:hover {
  color: #006fb8;
  cursor: pointer;
}
.el-tabs >>> .el-tabs__item {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  padding: 0 10px;
}
.el-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
  background: #e8e8e8;
}
.el-tabs >>> .el-tabs__nav-wrap::after:hover {
  color: #006fb8;
}
.el-tabs >>> .el-tabs__active-bar {
  height: 2px;
  background-color: #006fb8;
}
.el-tabs >>> .el-tabs__header {
  margin: 0px !important;
}
.el-tabs >>> .el-tabs__nav-wrap::after {
  position: static !important;
}
.box12 {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 16px;
  width: 100%;
  height: 57px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(109, 109, 109, 0.35);
  align-items: center;
}
.saveBtn {
  width: 320px;
  height: 36px;
  background: #006fb8;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  letter-spacing: 2px;
  border: none;
  border-radius: 4px;
}
.bao >>> .el-card {
   border: none !important;
}
.bao >>>.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
    box-shadow: none !important;
}













</style>
